import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ConfirmarPagamentoLayer from "../components/ConfirmarPagamentoLayer";
import { useTranslation } from "../i18n/I18nContext";

const ConfirmarPagamentoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("propina.breadcrumb.confirm")} />
      <ConfirmarPagamentoLayer />
    </MasterLayout>
  );
};

export default ConfirmarPagamentoPage;
